import React from 'react';
import { useFela } from 'react-fela';
import { useNavigate } from 'react-router';

import type { IStyle } from 'fela';

import { Box } from '../box/box';
import * as styles from './NavButton.style';

import type { Theme } from '../../../types';

interface NavButtonProps {
  // A path to navigate to, or a history delta such as -1 to go back.
  to: string | number;
  style?: IStyle;
  className?: string;
  children?: React.ReactNode;
}

const NavButton: React.FC<NavButtonProps> = ({ children, to, style, className }) => {
  const { theme } = useFela<Theme>();
  const navigate = useNavigate();

  return (
    <Box
      as="button"
      className={className}
      style={{ ...styles.button(theme), ...style }}
      onClick={() => {
        if (typeof to === 'number') {
          navigate(to);
          return;
        }

        navigate(to);
      }}
    >
      {children}
    </Box>
  );
};

export default NavButton;
